import React, { useState, useEffect } from 'react';

import { Grid } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { HeaderMarginContainer } from 'Deer/components/HeaderComponents/HeaderMarginContainer';
import { useDispatch } from 'react-redux';
import { Button } from 'styles/admin';

import { endpoints } from 'constants/endpoints';
import { JiraLogoSrc } from 'constants/icons';

import { getAuthDetails } from 'services/plugins';
import { showErrorSnackbar } from 'services/snackbar';

import { Typography16, Typography17 } from 'uiToolkit/Typography';

import InstalledButton from '../InstalledButton';
import PluginFeatures from '../pluginFeatures';
import { StyledContainer, Logo } from '../styles';
import CurrentConnectionsSection from './currentConnectionsSection';
import GuideSection from './guideSection';
import InstallationSection from './installationSection';
import LinkSettingsSection from './linkSettingsSection';

const thirdPartyType = 'JIRA';

const JiraPlugin = () => {
  const dispatch = useDispatch();
  const [currentConnection, setCurrentConnection] = useState(null);
  const [loading, setLoading] = useState(false);

  const getData = () => {
    setLoading(true);
    getAuthDetails({ thirdPartyType })
      .then((res) => setCurrentConnection(res))
      .catch((err) => dispatch(showErrorSnackbar('Sorry, unable to fetch the connections')))
      .finally(() => setLoading(false));
  };

  useEffect(getData, []);

  const onGetClick = () => window.open(endpoints.plugins.jiraAuth, '_blank');

  return (
    <StyledContainer>
      <HeaderMarginContainer>
        <Grid container spacing={4}>
          <Grid item>
            <Logo src={JiraLogoSrc} width={80} />
          </Grid>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Grid item xs={6}>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Typography16 gutterBottom>Jira Plugin</Typography16>
                <Typography17 bottomGutter={3}>
                  Seamlessly connect your OKRs, Goals and Tasks in Mesh with JIRA
                </Typography17>
              </Grid>
              <Grid item>
                {currentConnection ? (
                  <InstalledButton isDisabled>Connected</InstalledButton>
                ) : (
                  <Button blue size="large" topGutter={4} onClick={onGetClick} disabled={loading || currentConnection}>
                    Get
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </HeaderMarginContainer>
      {!loading ? (
        <>
          {!currentConnection ? (
            <>
              <LinkSettingsSection reset={getData} />
              <InstallationSection />
            </>
          ) : (
            <CurrentConnectionsSection connection={currentConnection} />
          )}
        </>
      ) : (
        <Skeleton height="12rem" />
      )}
      {!loading && currentConnection && (
        <PluginFeatures thirdPartyType={thirdPartyType.toLowerCase()} heading="Enable features" />
      )}
      <GuideSection />
    </StyledContainer>
  );
};

export default JiraPlugin;
